import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';

import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  Typography
} from '@material-ui/core';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faUser } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  },
  toolbar: {
    height: 64
  }
}));

export const TopBar = ({
  className,
  onMobileNavOpen,
  currentRouteTitle,
  ...rest
}: any) => {

  const classes = useStyles();

  // const [notifications] = useState([]);

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
    >
      <Toolbar className={classes.toolbar}>

        <Hidden mdDown>
          <RouterLink to="/">
            <img src={'/favicon-32x32.png'} alt="APC Mobile" />
          </RouterLink>
          <Typography color="initial" variant="h6" >
            APC-MOBILE
          </Typography>
          <Box flexGrow={1} />
          {/* <IconButton color="inherit">
            <Badge badgeContent={notifications.length} color="primary" variant="dot" >
              <FontAwesomeIcon icon={faAddressCard} />
            </Badge>
          </IconButton> */}
          <IconButton color="inherit">
            <FontAwesomeIcon icon={faUser} />
          </IconButton>
        </Hidden>

        <Hidden lgUp>
          <IconButton edge="start" color="inherit" onClick={onMobileNavOpen} >
            <FontAwesomeIcon icon={faBars} />
          </IconButton>
          <Typography color="initial" variant="h6" >
            {currentRouteTitle}
          </Typography>
          <Box flexGrow={1} />
          <RouterLink to="/">
            <img src={'/favicon-32x32.png'} alt="APC Mobile" />
          </RouterLink>
        </Hidden>

      </Toolbar>
    </AppBar>
  );
};
